import React, { FunctionComponent } from "react";
import { Box } from "@mui/material";
import { PurchaseActions } from "./components";
import { PdfFooterProps } from "./types";

export const PurchasePdfFooter: FunctionComponent<PdfFooterProps> = ({
  documentId,
  setScale,
  downloadUrl,
  actionsDisabled,
  setFileName,
  fileName,
}) => {
  const handleFileName = (file: any) => {
    setFileName(file);
  };

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.primary.main,
        padding: "12px 24px",
        color: "#ffffff",
      })}
    >
      <PurchaseActions
        documentId={documentId}
        actionsDisabled={actionsDisabled}
        downloadUrl={downloadUrl}
        fileName={fileName}
        setScale={setScale}
        handleFileName={handleFileName}
      />
    </Box>
  );
};
